export default __webpack_public_path__ + "assets/venue.8739ca84.svg";